import { styled } from '@mui/material/styles';
import DialogContent from '@mui/material/DialogContent';
import Box from '@mui/material/Box';

export const Content = styled(DialogContent)(({ theme }) => ({
	display: 'flex',
	flexDirection: 'column',
	alignItems: 'center',
	maxWidth: '400px',
	padding: theme.spacing(2),
}));

export const LogoBox = styled(Box)(({ theme }) => ({
	backgroundColor: '#F7F7F7',
	borderRadius: '15px',
	padding: theme.spacing(3),
	width: '100%',
	marginBottom: theme.spacing(1),
}));

export const StatsRow = styled(Box)(({ theme }) => ({
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'center',
	gap: theme.spacing(2.5),
	marginTop: theme.spacing(2),
}));

export const Stat = styled(Box)(() => ({
	textAlign: 'center',
}));

export const StatValue = styled('div')(({ theme }) => ({
	fontSize: 20,
	fontWeight: 800,
	lineHeight: 1.1,
	letterSpacing: '-0.01em',
	color: theme.colors.text,
}));

export const StatLabel = styled('div')(({ theme }) => ({
	fontSize: 12,
	fontWeight: 500,
	color: theme.colors.descriptionText,
}));

export const StatDivider = styled('div')(({ theme }) => ({
	width: '1px',
	height: '28px',
	backgroundColor: theme.colors.border,
}));

export const Qr = styled('div')(({ theme }) => ({
	maxWidth: '210px',
	margin: `${theme.spacing(3)} ${theme.spacing(4)} ${theme.spacing(4)}`,
}));

export const DownloadButton = styled('img')(() => ({
	display: 'block',
	maxHeight: '44px',
	maxWidth: '148px',
}));
